"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TimeHhMm_1 = require("../TimeHhMm");
var widgets_1 = require("@tableau/widgets");
var SelfServiceSchedulePane_1 = require("../SelfServiceSchedulePane");
var typestyle_1 = require("typestyle");
var StaticInitializers_1 = require("../StaticInitializers");
/** TODO: This should ideally come from shared-widgets **/
var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeChangeHandler = function (e) {
            _this.timeChangedInternal(e);
        };
        return _this;
    }
    TimePicker.prototype.timeChangedInternal = function (htmlTime) {
        this.props.onTimeChange(TimeHhMm_1.TimeHhMm.fromHHMMString(htmlTime));
    };
    /**
     * getMinuteOptions:
     * if has startFrom property, set the hour to prop's hour
     *   if in the first hour, set minute to the prop's minute
     *   else minute set to 0
     * else hour set to 0
     */
    TimePicker.prototype.getMinuteOptions = function () {
        var result = [];
        var minuteInterval = this.props.minuteInterval;
        if (!minuteInterval) {
            minuteInterval = this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh
                ? StaticInitializers_1.StaticInitializers.MINUTES_IN_HOUR // BridgeExtractRefresh pane only has options on the hour
                : 5; // The Default pane allows choosing any 5 minute increment
        }
        for (var hour = this.props.startFrom ? this.props.startFrom.hour : 0; hour < StaticInitializers_1.StaticInitializers.HOURS_IN_DAY; hour++) {
            var startMinute = this.props.startFrom
                ? this.props.startFrom.hour === hour
                    ? this.props.startFrom.minute
                    : 0
                : 0;
            for (var minute = startMinute; minute < StaticInitializers_1.StaticInitializers.MINUTES_IN_HOUR; minute += minuteInterval) {
                var hmFormatted = TimeHhMm_1.TimeHhMm.toHHMMString(hour, minute);
                result.push({ value: hmFormatted, content: hmFormatted });
            }
        }
        return React.createElement(widgets_1.List, { items: result, style: { maxHeight: '300px', overflow: 'auto' } });
    };
    TimePicker.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(widgets_1.SingleSelectDropdown, { label: this.props.caption, value: this.props.selectedValue ? this.props.selectedValue.toHHMMString() : '00:00', onChange: this.timeChangeHandler, testId: this.props.testSelectId || 'timePickerDefaultTestId', type: widgets_1.DropdownButtonType.Line, list: this.getMinuteOptions(), className: typestyle_1.style(this.props.style) })));
    };
    return TimePicker;
}(React.Component));
exports.TimePicker = TimePicker;
//# sourceMappingURL=TimePicker.js.map